module.exports = __webpack_public_path__ + "static/media/apple-news-logo.e40832cd.png";